import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

export default class extends Controller {
    static targets = ["box"];

    connect() {
        console.log("Connected box");
    }

    toggle() {
        const that = $(this.element);
        const box = this.boxTarget;
        $(box).toggleClass("open");
    }
}